import { animate, keyframes, style, transition, trigger } from '@angular/animations';

/**
 * Entry animation for the Flexi status emojis (happy / neutral / sad).
 *
 * Bound as `[@flexiEmojiEntry]="emojiEntryState"`. The state is the switch:
 * only `void => animate` has a transition, so binding EMOJI_ENTRY_IDLE renders
 * the emoji with no animation at all. That is what keeps this a *one-time*
 * effect — see FlexiEmojiEntryService for the latch that decides which state
 * a component binds.
 *
 * The element is inside an *ngIf/async render in every call site, so the
 * transition is `void => …` (element insertion) rather than a state change.
 */
export const EMOJI_ENTRY_ANIMATE = 'animate';
export const EMOJI_ENTRY_IDLE = 'idle';

export const flexiEmojiEntry = trigger('flexiEmojiEntry', [
  transition(`void => ${EMOJI_ENTRY_ANIMATE}`, [
    animate(
      '620ms ease-out',
      keyframes([
        style({ opacity: 0, transform: 'scale(0.35) rotate(-22deg)', offset: 0 }),
        style({ opacity: 1, transform: 'scale(1.14) rotate(7deg)', offset: 0.5 }),
        style({ opacity: 1, transform: 'scale(0.95) rotate(-4deg)', offset: 0.75 }),
        style({ opacity: 1, transform: 'scale(1.02) rotate(1deg)', offset: 0.9 }),
        style({ opacity: 1, transform: 'scale(1) rotate(0)', offset: 1 }),
      ])
    ),
  ]),
]);
